module.exports = __webpack_public_path__ + "static/media/lock_black_background.c34580cc.svg";